import { Row, Col } from "react-bootstrap";
import FlowSelector from "../components/FlowSelector";

function HomeShowcase() {
  return (
    <section className="home-showcase my-5">
      <div className="container">
        <Row>
          <Col xs={12} md={7}>
            <h2 className="text-aqua fs-5 fw-bold">For vehicle specialists</h2>
            <h1>Lorem ipsum dolor sit amet.</h1>
            <p className="m-0">
              Your customer drives through sleek, modern cameras installed at
              your site. Lorem ipsum dolor sit amet, consectetur adipiscing.{" "}
            </p>
          </Col>
        </Row>

        <Row>
          <FlowSelector />

          <Col xs={12} md={3}>
            <div className="feature-title-container my-3">
              <div className="vertical-pipe"></div>
              <h5 className="m-0 fw-bold">Perform real-time verification</h5>
            </div>
            <p>
              ProofTec quickly confirms or dismisses damage claims in real time.
            </p>
          </Col>
          <Col xs={12} md={9}>
            <img
              alt="Car image"
              style={{ width: "100%", height: "500px", objectFit: "cover" }}
              className="object-cover rounded"
              src="assets/image.png"
            />
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default HomeShowcase;
